import PropTypes from "prop-types";

/* Shared empty / loading / error placeholder for the results area. */
const StateMessage = ({ tone = "idle", title, text, children }) => (
  <div className={`c4trk__state c4trk__state--${tone}`} role={tone === "error" ? "alert" : undefined}>
    {tone === "loading" ? (
      <span className="c4trk__spinner" aria-hidden="true" />
    ) : null}
    <h2 className="c4trk__state-title">{title}</h2>
    {text ? <p className="c4trk__state-text">{text}</p> : null}
    {children}
  </div>
);

StateMessage.propTypes = {
  tone: PropTypes.oneOf(["idle", "loading", "error"]),
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
};

export default StateMessage;
